import React, { useState, useEffect, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Framework from "../../Images/frameworks.svg";
import logoTextData from "../../resources/logoTextData.json";
import imageHeader from "../../resources/imageHeader.json";
import SubHeadings from "../WhatWeDo/components/SubHeadings.js";
import ImageHeader from "../WhatWeDo/components/ImageHeader.js";
import framework from "../../Images/ApplicationFrame.jpg";
import { ReactComponent as Lock } from "../../Images/shield-lock.svg";
import { ReactComponent as Roles } from "../../Images/person-gear.svg";
import { ReactComponent as PassKey } from "../../Images/key.svg";
import { ReactComponent as JSON } from "../../Images/filetype-json.svg";
import { ReactComponent as SignOn } from "../../Images/ui-checks.svg";
import { ReactComponent as MultiLanguage } from "../../Images/translate.svg";
import { ReactComponent as LogError } from "../../Images/send-x.svg";
import { ReactComponent as SearchEngineOptimization } from "../../Images/searchEngin.svg";
import ContactUs from "../Contact/ContactUs";
import Footer from "../Footer/Footer";
import IconCard from "../WhatWeDo/components/IconCard";
import { ReactComponent as Fingerprint } from "../../Images/fingerprint.svg";
import { ReactComponent as Amazon } from "../../Images/amazon.svg";
import { ReactComponent as Mobile } from "../../Images/tablet.svg";
import { ReactComponent as EmailCheck } from "../../Images/envelope-check.svg";
import { ReactComponent as DataEfficient } from "../../Images/database-fill-check.svg";
import { ReactComponent as Cache } from "../../Images/stack.svg";
import SliderPage from "../WhatWeDo/components/SliderPage.js";
import RealEstateTechstack from "../Techstack/RealEstateTechstack.js";
import WhoWeAre from "../WhoWeAre/WhoWeAre";
import { ContactUsPDF } from "./CommonPages/ContactUsPDF.js";
import Slider from "../WhatWeDo/components/Slider.js";
import WhoWeArePDF from "./CommonPages/WhoWeArePDF.js";
import TeckStackPDF from "./CommonPages/TeckStackPDF.js";
const ThreeColumnContainer = styled.div`
  ${tw`mt-1 flex flex-col items-center lg:items-stretch lg:flex-row  md:flex-row md:items-stretch md:justify-center sm:flex-wrap lg:justify-center max-w-screen-lg mx-auto`}
`;

const Wrapper = tw.div`max-w-screen-xl mx-auto py-2  mb-10`;
const Description = tw.p`px-6 font-semibold py-2  text-xl text-gray-900 text-justify`;
const WrapperDescription = tw.div`max-w-screen-xl mx-auto mt-8   `;
const TwoCol = styled.div`
  ${tw`flex justify-center max-w-screen-xl mx-auto`}
`;

const AppInBoxPDF = ({ title }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.title = "Welcome to Iqura - Application-in-a-box";
    let descMeta = document.querySelector("meta[name='description']");
    descMeta.setAttribute(
      "content",
      "Streamline your new application development and leverage our expertise and ready-made frameworks for faster enterprise application development. Our framework comprises cloud-ready .NET APIs with a JS-based responsive front-end UI along with comprehensive identity management using AWS Cognito. When time to market matters, we deliver. "
    );
    let keyword = document.querySelector("meta[name='keywords']");
    keyword.setAttribute(
      "content",
      "Application framework, Application-in-a-box,Secure  Authentication, JWT-based Authentication,Authentication Token Management, Registration & Sign-on, Password Management, Roles and Claim Management, Email & Multi-factor authentication (MFA), CORS and API Security, AWS Secrets Implementation, Reliability &  Maintenance, Error Logging, Mobile Ready, Efficient Data Handling, Caching Mechanisms, Multi-language Support"
    );
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href = "https://www.iqura.tech/what-we-do/application-framework";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const LogoContainer = tw.div`flex lg:justify-end absolute mb-10 z-1 w-full`;
  const LogoText = tw.h5`ml-0 text-6xl pt-5 text-white font-bold `;
  let [current, setCurrent] = useState(0);

  let slidesData = [
    {
      image: framework,
      typeID: "element4_app",
      typedHead:
        "Get off the ground running with your new enterprise app with our robust framework and repository.",
      heading1: "Application -",
      heading2: "in-a-box",
      route: "/what-we-do/application-framework",
      routeState: "",
      buttonName: "Visit",
    },
  ];

  let slides = [<SliderPage slidesData={slidesData[0]} imagehalf={true} />];

  const imgStyle = { width: "40px", height: "40px" };

  let ExpertiseData = [
    {
      imageSrc: <JSON style={imgStyle} />,
    },
    {
      imageSrc: <Fingerprint style={imgStyle} />,
    },
    {
      imageSrc: <SignOn style={imgStyle} />,
    },
    {
      imageSrc: <PassKey style={imgStyle} />,
    },
    {
      imageSrc: <Roles style={imgStyle} />,
    },
    {
      imageSrc: <EmailCheck style={imgStyle} />,
    },

    {
      imageSrc: <Lock style={imgStyle} />,
    },
    {
      imageSrc: <Amazon style={imgStyle} />,
    },
  ];

  let maintenanceImages = [
    {
      imageSrc: <LogError style={imgStyle} />,
    },
    {
      imageSrc: <Mobile style={imgStyle} />,
    },
    {
      imageSrc: <DataEfficient style={imgStyle} />,
    },
    {
      imageSrc: <Cache style={imgStyle} />,
    },
    {
      imageSrc: <MultiLanguage style={imgStyle} />,
    },
    {
      imageSrc: <SearchEngineOptimization style={imgStyle} />,
    },
  ];

  const ourExpertise = logoTextData.ourservices.ourexpertise.map(
    (item, index) => (
      <IconCard
        key={index}
        title={item.title}
        description={item.description}
        imageSrc={ExpertiseData[index].imageSrc}
      />
    )
  );

  const maintenance = logoTextData.ourservices.maintenance.map(
    (item, index) => (
      <IconCard
        key={index}
        title={item.title}
        description={item.description}
        imageSrc={maintenanceImages[index].imageSrc}
      />
    )
  );

  return (
    <div className="overflow-hidden relative ">
     <div style={{visibility:"hidden",position:"absolute" , top: "-9999px"}}>
  <Slider/>
 </div>
   <div>
    
   </div>
      <div className="" style={{ height: "100vh" }}>
        <div className="overflow-hidden relative  ">
          <LogoContainer>
            <div className="flex lg:justify-end w-full mr-16  ">
              <LogoText className="logoFontFamily">Iqura</LogoText>
            </div>
          </LogoContainer>
          <div
            className="flex transition-transform ease-out duration-300 "
            style={{
              transform: `translateX(-${current * 100}%)`,
            }}
          >
            {slides.map((s) => {
              return (
                <div className="z-22" style={{ width: "100%" }}>
                  {s}
                </div>
              );
            })}
          </div>

          <div className="absolute bottom-0 py-4 flex justify-center gap-3 w-full   ">
            {slides.map((s, i) => {
              return (
                <div
                  onClick={() => {
                    setCurrent(i);
                  }}
                ></div>
              );
            })}
          </div>
        </div>
       
        <TwoCol>
          <WrapperDescription>
            <Description
              style={{
                backgroundColor: "white",
                marginTop: `${window.innerWidth <= 425 ? -140 : -35}px`,
                padding: "40px",
                transform:"scale(1.25)"
              }}
            >
              <ImageHeader
                imageHeaderData={imageHeader.Framework}
                imgsource={Framework}
              />
            </Description>
          </WrapperDescription>
        </TwoCol>
      </div>
  <WhoWeArePDF/>
      <div className ="  flex justify-center items-center  "style={{ height: "100vh" }}>
        <div className="px-20 pb-32"  style={{ transform:"scale(1.35)" }} >
          <Wrapper>
            <SubHeadings heading1="Secure" heading2="Authentication" />
          </Wrapper>

          <ThreeColumnContainer>{ourExpertise}</ThreeColumnContainer>
        </div>
      </div>

      <div  className =" flex justify-center items-center  " style={{ height: "100vh"}}>
      <div className="px-20 pb-32"  style={{ transform:"scale(1.35)" }}  >
          <Wrapper>
            <SubHeadings heading1="Reliability &" heading2="Maintenance" />
          </Wrapper>
          <ThreeColumnContainer>{maintenance}</ThreeColumnContainer>
        </div>
      </div>
<TeckStackPDF/>

<ContactUsPDF/>
    </div>
  );
};

export default AppInBoxPDF;
